/* ⚛ REACT */
import { useEffect, useRef, useState } from "react";

/* 📦 LIBS */
import { toast } from "react-toastify";
import { useTranslation } from "react-i18next";
import { useNavigate, useParams } from "react-router";

/* 🧩 COMPONENTS */
import { InputSelect, Input, InputCheckbox, Label, Button, CustomLoading, SaveIcon } from "../../../../Components";

/* 🔗 SERVICE */
import { PartsComandServices } from "../../../../Services/partscommandService";

/* 📁 ASSETS*/
import { Excluir } from "../../../../Assets/icons";

/* 🎨 STYLES */
import { Container, TitleContainer, Title, ContainerRow, ContainerColumn, ImageIcon, ButtonsContainer } from "./styles";

/* 🔧 UTILS */
import { isValidField } from "../../../../util/validate";

const ViewPartCommandsVariablesAcceptUnits = () => {
    const { t } = useTranslation();
    const navigate = useNavigate();
    document.title = "Configuração de unidade";
    const [loading, setLoading] = useState(true);
    const [parts, setParts] = useState([]);

    let { id } = useParams();
    const Services = useRef(new PartsComandServices());

    const partCommandField = useRef();
    const nameField = useRef();
    const customUnitField = useRef();
    const proportionField = useRef();

    const partCommandValue = useRef();
    const nameValue = useRef();
    const customUnitValue = useRef();
    const proportionValue = useRef();
    const isActiveValue = useRef(false);

    const [partCommand, setPartCommand] = useState();

    useEffect(() => {
        async function getGroupVariable(){
            setLoading(true)
            let currentItem = await Services.current.getUnit(id);
            if(currentItem){
                setPartCommand(currentItem);
            }
            setLoading(false)
        }

        async function getParts(){
            let currentItem = await Services.current.getAllPartCommands();
            setParts(currentItem);
        }
        getGroupVariable();
        getParts();
    }, [id]);

    // method-spoofing
    // Salva as edições
    async function Save(){
        if(isValidField(partCommandValue.current)){
            let form = new FormData();
            if(partCommandValue.current){form.append('command_variable', partCommandValue.current)}
            if(customUnitValue.current){form.append('custom_unit', customUnitValue.current)}
            if(nameValue.current){form.append('name', nameValue.current)}
            if(proportionValue.current){form.append('proportion', proportionValue.current)}
            form.append('isactive', isActiveValue.current ? 1 : 0)

            form.append('_method', 'PATCH')

            let currentitem = await Services.current.editUnit(id, form)
            if(currentitem){
                setPartCommand(currentitem);
            }
        }else{
            toast(t("message.save"), {
                position: "top-center",
                type: 'info',
                autoClose: 3000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: false,
                draggable: false,
                progress: undefined,
            });
        }
    }

    return (
        <>  
            <Container>
                <TitleContainer>
                    <Title>Configuração de unidade</Title>
                </TitleContainer>

                {loading ? <CustomLoading width={'150px'} height={'150px'}/>:
                <>
                    <ContainerRow onSubmit={(e)=> e.preventDefault()}>
                        <ContainerColumn>
                            <Label text={"Variável"} aling="flex-start"/>
                            <InputSelect
                                key={'variable'}
                                name={'variable'}
                                id={'variable'}
                                placeholder={"Variável"}
                                invalidMessage = {"Variável!"}
                                options={parts}
                                innerRef={partCommandField}
                                value={partCommand?.command_variable}
                                validationFunction = {(value) => isValidField(value)}
                                onchange={(value) => partCommandValue.current = value}>
                            </InputSelect>      
    
                            <Label text={"Nome"} aling="flex-start"/>
                            <Input
                                key={'name'}
                                name={'name'}
                                id={'name'}
                                placeholder={"Nome"}
                                invalidMessage = {"Nome inválida!"}
                                innerRef={nameField}
                                value={partCommand?.name}
                                validationFunction = {(value) => isValidField(value)}
                                onchange={(value) => nameValue.current = value}>
                            </Input>                
                        </ContainerColumn>
    
                        <ContainerColumn>
                            <Label text={"Unidade"} aling="flex-start"/>
                            <Input
                                key={'unit'}
                                name={'unit'}
                                id={'unit'}
                                placeholder={"Unidade"}
                                invalidMessage = {"Unidade inválida!"}
                                innerRef={customUnitField}
                                value={partCommand?.custom_unit}
                                validationFunction = {(value) => isValidField(value)}
                                onchange={(value) => customUnitValue.current = value}>
                            </Input>
    
                            <Label text={"Proporção"} aling="flex-start"/>
                            <Input
                                key={'proportion'}
                                name={'proportion'}
                                id={'proportion'}
                                type={'Number'}
                                placeholder={"Proporção"}
                                invalidMessage = {"Proporção inválida!"}
                                innerRef={proportionField}
                                value={partCommand?.proportion}
                                validationFunction = {(value) => isValidField(value)}
                                onchange={(value) => proportionValue.current = value}>
                            </Input>
    
                            <InputCheckbox text={t("inputs.isActive.label")} onChange={(value)=> {isActiveValue.current = value; return true}}/>
                        </ContainerColumn>
                    </ContainerRow>

                    <ButtonsContainer>
                        <Button text={t("buttons.save")} width={'150px'} icon={<SaveIcon/>} onClick={()=>Save()}/>
                        <Button text={t("buttons.delete")} width={'150px'} color={'white-red'} onClick={async function(){
                            await Services.current.deleteUnit(id);
                            navigate('/PartCommandsVariablesAcceptUnits')
                        }} icon={<ImageIcon src={Excluir}/>}/>
                    </ButtonsContainer>
                </>}

            </Container>
        </>
    );
}

export default ViewPartCommandsVariablesAcceptUnits;